import { render } from "./CompartilhamentosSite.vue?vue&type=template&id=05ebece7"
import script from "./CompartilhamentosSite.vue?vue&type=script&lang=js"
export * from "./CompartilhamentosSite.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__